<template>
	<v-container fluid class="gancho-section pa-12">
		<v-container class="pa-10">
			<v-row align="center" justify="center">
				<v-col cols="12" md="8" class="text-center">
					<h2 class="gancho-title">
						Pronto para transformar a gestão <br>
						da sua transportadora?
					</h2>
					<p class="gancho-subtitle">
						Junte-se a dezenas de transportadoras que já eliminaram o caos operacional e<br>
						aumentaram seus lucros com o CargasZap.
					</p>
					<div class="gancho-buttons mt-6">
						<v-btn
							large
							rounded
							color="#10b981"
							class="mr-4 white--text font-weight-bold glow-btn"
							elevation="2"
							to="/cadastro"
						>
							Teste Gratis
							<v-icon right>mdi-arrow-right</v-icon>
						</v-btn>
						<v-btn
							large
							rounded
							outlined
							color="#1ED760"
							class="font-weight-bold whatsapp-btn"
						>
							<v-icon left>mdi-whatsapp</v-icon>
							Falar no WhatsApp
						</v-btn>
					</div>
				</v-col>
			</v-row>
		</v-container>
	</v-container>
</template>

<script>
export default {
	name: "GanchoFinal"
}
</script>

<style scoped>
.gancho-section {
	background: radial-gradient(circle at center, #0f172a, #020617);
	min-height: 45vh;
	display: flex;
	align-items: center;
	color: white;
}

.gancho-title {
	font-size: 38px;
	font-weight: 800;
	line-height: 1.2;
	margin-bottom: 18px;
}

.gancho-subtitle {
	color: #94a3b8;
	font-size: 17px;
	margin-bottom: 32px;
}

.gancho-buttons {
	display: flex;
	justify-content: center;
	gap: 18px;
}

.glow-btn {
	box-shadow: 0 0 20px #10b98166;
}

.whatsapp-btn {
	background: rgba(255,255,255,0.04);
	border: 1px solid #1ED760;
	color: #fff;
}
</style>